export const LOCAL_STORAGE_KEY = 'isSubscribed';
